"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpHandlerBase = void 0;
class HttpHandlerBase {
    async SendAsync(requestInfo, requestInit) {
        const response = await this.sendRequest(requestInfo, requestInit);
        if (!response.ok) {
            let error;
            try {
                const almeErrorResponse = await response.json();
                error = new Error(almeErrorResponse.Message);
            }
            catch (_a) {
                error = new Error('An error has occurred.');
            }
            error.httpStatusCode = response.status;
            throw error;
        }
        //No Content
        if (response.status === 204 || (response.status === 200 && this.hasEmptyBody(response))) {
            return;
        }
        return await response.json();
    }
    async SendRawAsync(requestInfo, requestInit) {
        const response = await this.sendRequest(requestInfo, requestInit);
        if (!response.ok) {
            const error = new Error('An error has occurred.');
            error.httpStatusCode = response.status;
            throw error;
        }
        return response;
    }
    hasEmptyBody(response) {
        return (!!response.headers.get('Content-Length') && response.headers.get('Content-Length') <= 0);
    }
    async sendRequest(requestInfo, requestInit) {
        let response;
        if (requestInit) {
            if (requestInit.setSignal && requestInit.clearTimeout) {
                requestInit.setSignal();
                response = await fetch(requestInfo, requestInit);
                requestInit.clearTimeout();
            }
            else {
                response = await fetch(requestInfo, requestInit);
            }
        }
        else {
            response = await fetch(requestInfo);
        }
        return response;
    }
}
exports.HttpHandlerBase = HttpHandlerBase;
//# sourceMappingURL=HttpHandlerBase.js.map